define("shared/components/shared/address-fields/error", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component"], function (_exports, _component, _templateFactory, _object, _service, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if (and @missingValue (is-present @emptyText))}}
    <span class="o--form__helpText is--error u--m__tb__xs" data-error>{{@emptyText}}</span>
  {{else if (is-present @suggestion)}}
    {{#if (is-present this.suggestedValue)}}
      <span class="o--form__helpText is--error u--m__tb__xs" data-error>
        {{t "errors.address.suggested"}}
        <span class="u--p__r__xs">{{this.suggestedValue}}</span>
        <Shared::Ui::Button
          @onClick={{this.setSuggestion}}
          @text={{t "account.subscription.billing.address.change"}}
          @variant="unstyled"
          class="u--text--hl u--inline u--p__0"
        />
      </span>
    {{else}}
      <span class="o--form__helpText is--error u--m__tb__xs">{{@invalidText}}</span>
    {{/if}}
  {{/if}}
  */
  {
    "id": "J19QcT6I",
    "block": "[[[41,[28,[37,1],[[30,1],[28,[37,2],[[30,2]],null]],null],[[[1,\"  \"],[10,1],[14,0,\"o--form__helpText is--error u--m__tb__xs\"],[14,\"data-error\",\"\"],[12],[1,[30,2]],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,2],[[30,3]],null],[[[41,[28,[37,2],[[30,0,[\"suggestedValue\"]]],null],[[[1,\"    \"],[10,1],[14,0,\"o--form__helpText is--error u--m__tb__xs\"],[14,\"data-error\",\"\"],[12],[1,\"\\n      \"],[1,[28,[35,3],[\"errors.address.suggested\"],null]],[1,\"\\n      \"],[10,1],[14,0,\"u--p__r__xs\"],[12],[1,[30,0,[\"suggestedValue\"]]],[13],[1,\"\\n      \"],[8,[39,4],[[24,0,\"u--text--hl u--inline u--p__0\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,0,[\"setSuggestion\"]],[28,[37,3],[\"account.subscription.billing.address.change\"],null],\"unstyled\"]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,1],[14,0,\"o--form__helpText is--error u--m__tb__xs\"],[12],[1,[30,4]],[13],[1,\"\\n\"]],[]]]],[]],null]],[]]]],[\"@missingValue\",\"@emptyText\",\"@suggestion\",\"@invalidText\"],false,[\"if\",\"and\",\"is-present\",\"t\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/address-fields/error.hbs",
    "isStrictMode": false
  });

  let AddressErrorComponent = (_class = class AddressErrorComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "address", _descriptor, this);
    }

    get suggestedValue() {
      return this.args.suggestion.suggested;
    }

    setSuggestion() {
      this.args.setSuggestion(this.args.field, this.suggestedValue);
      this.address.clearSuggestion(this.args.field);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "setSuggestion", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setSuggestion"), _class.prototype)), _class);
  _exports.default = AddressErrorComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AddressErrorComponent);
});